import React from 'react';
import { connect } from 'react-redux';

import classes from './SelectionList.module.scss';

import Scroll from 'Flow2/components/UI/Container/Scroll';
import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';
import Input from 'Flow2/components/UI/Input/Input';
import Button from 'Flow2/components/UI/Button/Button';

import iconDelete from 'PMDB/assets/images/png_icons/cancel_icon_black.png';

import { FormattedMessage } from 'react-intl';

const MIN_INPUT_CHAR = 1;
const DEFAULT_VALUE_FIELD = "id";
const DEFAULT_LABEL_FIELD = "name";

const SelectionListInput = (props) => {
    if(!props.showInput) {
        return "";
    }
    
    return (<FlexRow className={[classes.Input, 'relative'].join(' ')}>
                <Input
                    value={props.value}
                    elementConfig={{type: 'text'}}
                    changed={props.changed}/>
                <img alt="" className={[classes.clear, 'pointer'].join(' ')} onClick={() => {props.clear()}} src={iconDelete} />
                <span className={[classes.open, classes[props.open]].join(' ')} onClick={() => {props.openHandler()}}/>
            </FlexRow>);
}

class SelectionList extends React.Component {
    
    constructor(props){
		super(props);
		this.state = {
            input: "",
            open: false,
            list: props.list || props.users,
            valueField: props.valueField || DEFAULT_VALUE_FIELD,
            labelField: props.labelField || DEFAULT_LABEL_FIELD,
            value: props.value || "",
            showInput: props.add ? true : false,
            minInput: props.minInput || MIN_INPUT_CHAR,
		};
    }
    
    onChangedHandler = (event) => {
        const input = event.target.value;
        let open = (input.length >= this.state.minInput);
        this.setState({ input: input, open: open });
    }
    
    onSelect = (value, label) => {
        this.setState({ input: label, open: false, value: value });
        this.props.add(value + "");
    }
    
    onOpenClick = () => {
        this.setState({ open: !this.state.open });
    }
    
    onClearInput = () => {
        this.setState({ input: "", open: false, value: "" });
        this.props.add("");
    }
    
    createSuggestions = () => {
        const list = [];
        if(this.state.open) {
            this.state.list.forEach((item, index) => {
                if(item[this.state.labelField].toLowerCase().indexOf(this.state.input.toLowerCase()) !== -1) {
                    list.push(<span className="pointer" key={index} onClick={() => this.onSelect(item[this.state.valueField], item[this.state.labelField])}>{item[this.state.labelField]}</span>);
                }
            });
        }
        
        return (
            <Scroll className={[classes.Suggestions, classes[this.state.open]].join(' ')}>
                <FlexColumn className={classes.List}>
                    {list}
                </FlexColumn>
            </Scroll>
        );
    }
    
    render = () => {
        let label = this.state.input;
         
        if(!label) {
            // get label to display in list output
            this.state.list.forEach((item, index) => {
                if(item[this.state.valueField] == this.state.value) {
                    label = item[this.state.labelField];
                    return;
                }
            });
        }

        const input = (<SelectionListInput
                            showInput={this.state.showInput}
                            value={label}
                            changed={( event ) => this.onChangedHandler( event )}
                            clear={this.onClearInput}
                            openHandler={this.onOpenClick}
                            open={this.state.open}/>)
        
        const suggestions = this.createSuggestions();
        
        
        return (
            <FlexColumn className={classes.AddList}>
                { this.state.showInput ? input : label }
                <div className={classes.SuggestionsContainer}>
                    {suggestions}
                </div>
            </FlexColumn>
        );
    }
    
    static getDerivedStateFromProps(nextProps, prevState) {
        return { 
            input: (nextProps.add && prevState.input) || "",
            list: nextProps.list || nextProps.users,
            valueField: nextProps.valueField || DEFAULT_VALUE_FIELD,
            labelField: nextProps.labelField || DEFAULT_LABEL_FIELD,
            value: nextProps.value || "",
            showInput: (nextProps.add && true) || false,
            minInput: nextProps.minInput || MIN_INPUT_CHAR,
            open: (nextProps.add && prevState.open) || false
        };
    }

};

const mapStateToProps = (state, ownProps) => {
    return {
        users: state.user.users
    }
} 

export default connect(mapStateToProps)(SelectionList);
